import React, { Component } from 'react';
import dayjs from '../../../../dayjs/dayjs_timezone';
import Modal from '../../Modal';
import Select from '../Select';
import { timeFormat } from '../../../utilities/timeUtility';
import Translation from '../../../utilities/localizationUtility';
import { stringToBoolean } from '../../../utilities/conversionUtility';
import styled from "styled-components";

export default class TimeZone extends Component {
  onTimeZoneChange(timeZone) {
    const { setTimeZone } = this.props;
    setTimeZone(timeZone);
    this.closeModal();
  }

  content() {
    const { description: propDescription, timeZone } = this.props;
    const t = new Translation(this.props);
    const description = propDescription || `${t.key('timezoneLabel') || 'Timezone'}:`;
    const tooltip = `${description} ${this.timeZoneLabel(timeZone)}`;

    return (
      <>
        <i className="fa fa-globe mr5" aria-hidden="true" title={tooltip} />{ this.timeZoneLabel(this.props.timeZone) }
      </>
    );
  }

  timeZoneOption(timeZone) {
    const { timeZones } = this.props;
    return timeZones.find((tz) => tz.value === timeZone) || this.defaultTimeZoneOption(timeZone);
  }

  defaultTimeZoneOption(timeZone) {
    if (!timeZone) return {};
    const label = timeZone.split('/').pop().split('_').join(' ');
    return { value: timeZone, label };
  }

  timeZoneLabel(timeZone) {
    return this.timeZoneOption(timeZone).label;
  }

  timeZoneOptions() {
    return (
      [
        this.timeZoneOption(this.locationTimeZone()),
        this.timeZoneOption(dayjs.tz.guess()),
      ]
    );
  }

  timeZoneSelector() {
    const { style, selectStyles, timeZone } = this.props;
    const {
      color,
      inputsLabelsTextAlign,
      inputsBorderRadius,
    } = style.body || {};
    const t = new Translation(this.props);

    const StyledDiv = styled.div`
      .styled-select {
        .bta-react-select__control {
          border-radius: ${inputsBorderRadius}px;
        }
        span[class$="indicatorSeparator"] {
          background-color: ${color};
        }
        svg[class$="Svg"] {
          color: ${color};
        }
      }
        
      .titles {
        text-align: ${inputsLabelsTextAlign};
        width: 100%;
        display: block;  
      }
    `;

    return (
      <StyledDiv>
        <span
          className="titles"
          style={{
            ...style.title,
          }}
        >
          {t.key('timezone')}
        </span>
        <Select
          useValueAsDefault
          menuPlacement="bottom"
          styles={selectStyles}
          className="text-left mt10"
          name="timezone"
          value={timeZone}
          options={this.timeZoneOptions()}
          onChange={(x) => this.onTimeZoneChange(x)}
        />
      </StyledDiv>
    );
  }

  locationTimeZone() {
    const { selectedLocation } = this.props;
    return selectedLocation?.timezone || window.bta.timeZone;
  }

  render() {
    const {
      styles,
      className,
      localTimeZone,
      region,
      selectedTime,
      setting,
    } = this.props;
    const fontSize = styles.body?.fontSize >= '16px' ? `calc(${styles.body?.fontSize || '16px'} - 4px)` : '12px';
    const showTimezoneChooser = stringToBoolean(setting.show_timezone_chooser);
    const t = new Translation(this.props);

    if (!showTimezoneChooser) return '';
    if (this.locationTimeZone() === localTimeZone) {
      return (
        <p className={`${className || 'text-right'} pb15 pt15 timezone`} style={{ fontSize }}>
          {this.content()}
        </p>
      );
    }

    return (
      <div className={`timezone-line pb10 pt10 ${className}`}>
        <div style={{ width: '60%', fontSize }}>
          {this.content()}
        </div>
        <div style={{ textAlign: 'right' }}>
          <a onClick={() => { this.openModal(); }} style={{ textDecoration: 'underline', cursor: 'pointer', fontSize }}>{t.key('changeTimezone')}</a>
          <Modal
            title=""
            closeWord=""
            customStyle={{
              overlay: {
                borderRadius: `${styles.container?.widgetContainerBorderRadius}px`,
                margin: `${styles.container?.margin}px`,
                padding: `${styles.container?.padding}px`,
              },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: `${styles.container?.widgetContainerBorderRadius}px`,
            }}
            getOpenFn={(openFn) => { this.openModal = openFn; }}
            getCloseFn={(closeFn) => { this.closeModal = closeFn; }}
          >
            <div style={{ padding: `${styles.container?.padding}px` }}>
              {this.timeZoneSelector()}
              {selectedTime && (
                <>
                  <div>
                    <p>
                      {t.key('selectedTime')}: {dayjs(selectedTime).tz(this.locationTimeZone()).locale(region).format(`ddd, MMM DD, YYYY ${timeFormat()}`)}
                    </p>
                    <p>
                      <i className="fa fa-map-marker" aria-hidden="true"/> {this.timeZoneLabel(this.locationTimeZone())}
                    </p>
                  </div>
                  <div className="mt10 bt-1" style={{ borderColor: styles.body.color }}>
                    <p>
                      {t.key('yourTime')}: {dayjs(selectedTime).tz(localTimeZone).locale(region).format(`ddd, MMM DD, YYYY ${timeFormat()}`)}
                    </p>
                    <p>
                      <i className="fa fa-map-marker" aria-hidden="true"/> {this.timeZoneLabel(localTimeZone)}
                    </p>
                  </div>
                </>
              )}
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}
